import { z } from 'zod';
import { VALIDATION_LIMITS } from '../utils/constants';
export const userProfileUpdateSchema = z.object({
    first_name: z.string().min(1, 'First name is required').optional(),
    last_name: z.string().min(1, 'Last name is required').optional(),
    display_name: z.string().min(1, 'Display name is required').optional(),
    bio: z
        .string()
        .max(VALIDATION_LIMITS.BIO.MAX_LENGTH, 'Bio too long')
        .optional(),
    location: z.string().optional(),
    website: z.string().url('Invalid website URL').optional(),
});
export const socialLinksSchema = z.object({
    instagram: z.string().url('Invalid Instagram URL').optional(),
    twitter: z.string().url('Invalid Twitter URL').optional(),
    youtube: z.string().url('Invalid YouTube URL').optional(),
    tiktok: z.string().url('Invalid TikTok URL').optional(),
});
export const userPreferencesSchema = z.object({
    email_notifications: z.boolean().default(true),
    push_notifications: z.boolean().default(true),
    privacy_level: z.enum(['public', 'private', 'friends']).default('public'),
    preferred_units: z.enum(['metric', 'imperial']).default('metric'),
    theme: z.enum(['light', 'dark', 'auto']).default('auto'),
});
export const creatorApplicationSchema = z.object({
    bio: z
        .string()
        .min(50, 'Bio must be at least 50 characters')
        .max(VALIDATION_LIMITS.BIO.MAX_LENGTH, 'Bio too long'),
    specialties: z
        .array(z.string())
        .min(1, 'At least one specialty is required')
        .max(5, 'Maximum 5 specialties allowed'),
    experience_years: z.number().min(0).max(50),
    portfolio_links: z
        .array(z.string().url('Invalid portfolio URL'))
        .max(5, 'Maximum 5 portfolio links allowed'),
    social_links: socialLinksSchema,
    motivation: z
        .string()
        .min(100, 'Motivation must be at least 100 characters')
        .max(1000, 'Motivation too long'),
});
export const userSearchSchema = z.object({
    query: z.string().optional(),
    role: z.enum(['user', 'creator', 'moderator', 'admin']).optional(),
    status: z
        .enum(['active', 'inactive', 'suspended', 'banned', 'pending_verification'])
        .optional(),
    page: z.number().min(1).optional().default(1),
    limit: z.number().min(1).max(100).optional().default(20),
    sort_by: z
        .enum(['created_at', 'updated_at', 'username', 'display_name'])
        .optional()
        .default('created_at'),
    sort_order: z.enum(['asc', 'desc']).optional().default('desc'),
});
export const followUserSchema = z.object({
    user_id: z.string().min(1, 'User ID is required'),
});
export const blockUserSchema = z.object({
    user_id: z.string().min(1, 'User ID is required'),
    reason: z.string().optional(),
});
export const reportUserSchema = z.object({
    user_id: z.string().min(1, 'User ID is required'),
    reason: z.enum([
        'spam',
        'harassment',
        'inappropriate_content',
        'fake_account',
        'other',
    ]),
    description: z.string().min(10, 'Description must be at least 10 characters'),
});
